export default "/corgi/pageapps/prepurchase/_next/static/media/arrow-down-white.8b2ae316.svg";